/* eslint-disable @typescript-eslint/no-explicit-any */
import { Module } from '../react/context/module-federation-provider'

declare global {
  function __webpack_init_sharing__(scope: string): Promise<any>
  const __webpack_share_scopes__: { default: any }
}

interface Container {
  init(scope: any): Promise<void>
  get(module: string): Promise<any>
}

function loadScope(url: string, scope: string): Promise<Container> {
  const element = document.createElement('script')
  const promise = new Promise<Container>((resolve, reject) => {
    element.src = url
    element.type = 'text/javascript'
    element.async = true
    element.onload = () => resolve(window[scope as any] as any)
    element.onerror = reject
  })
  document.head.appendChild(element)
  promise.finally(() => document.head.removeChild(element))
  return promise
}

export async function loadModule(url: string, scope: string, module: string): Promise<Module> {
  try {
    const container = await loadScope(url, scope)
    await __webpack_init_sharing__('default')
    await container.init(__webpack_share_scopes__.default)
    const factory = await container.get(module)
    return factory()
  } catch (error) {
    console.error('Error loading module:', error)
    throw error
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */
